import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit{

  role: any;
  path: string;
  profileData: any;

  constructor(private profileService: ProfileService, private sanitizer: DomSanitizer, private storageService: StorageService, private authService: AuthService, private router: Router)
  {}

  async ngOnInit(): Promise<void> {
    let profileData = await this.profileService.getUserRoleAsync();
    this.role = profileData.roles[0].name;
  }

  /*getProfileData() {
    this.profileService.getProfileData().subscribe(res => {
      this.profileData = res.result;
      this.role = res.result.roles[0].name;
      localStorage.setItem('role', this.role)
      sessionStorage.setItem('profileData', JSON.stringify(this.profileData));

      this.getSantizeUrl(this.profileData.filestorage.path);
    })
  }*/

  getSantizeUrl(url: string) {
    this.path = environment.file + url;

    return this.sanitizer.bypassSecurityTrustUrl(this.path);
  }

  logout(): void {
    this.authService.logout().subscribe(res => {
      this.router.navigate(['/login']);
    });
  }

}
